import type { JSX } from 'react';

import { CLOSING_CTA } from './content.js';
import { EligibilityCta } from './eligibility-cta.js';
import { Band, BandHeading } from './sections.js';

/** Teal band before the testimonials: the second eligibility CTA plus the phone number. */
export function ClosingCta(): JSX.Element {
  return (
    <Band background="var(--tint-band)">
      <div className="grid items-center gap-10 lg:grid-cols-[1.1fr_0.9fr]">
        <div className="flex flex-col gap-4">
          <BandHeading lead="" accent={CLOSING_CTA.heading} />
          <p className="max-w-[46ch] nrx-prose text-[var(--ink)]">{CLOSING_CTA.body}</p>
          <p className="nrx-prose max-w-[46ch] font-semibold text-[var(--ink)]">
            {CLOSING_CTA.bodyStrong}
          </p>
          <p className="text-sm text-[var(--ink-soft)]">
            <strong className="font-semibold text-[var(--ink)]">Questions?</strong>{' '}
            {CLOSING_CTA.contact}
          </p>
          <EligibilityCta label={CLOSING_CTA.cta} />
        </div>
        {/* Transparent cut-out, so it sits directly on the band with no card or radius. */}
        <img
          src="/images/photo-member.webp"
          alt="Smiling NourishedRx member"
          className="mx-auto h-auto w-full max-w-[22rem] object-contain lg:max-w-none"
          width={760}
          height={600}
        />
      </div>
    </Band>
  );
}
